import { SETTINGS } from '../ids';
import { InstallLocation } from '../types';
export const ids = SETTINGS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Settings,
    method: 'addApplication',
    menuOrder: 4,
    uninstallable: true,
    page: {
        name: t('member-pages.settings.name'),
        shortDescription: t('member-pages.settings.subtitle'),
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        screenshots: [],
        description: '',
        origin: '',
        isNew: false,
    },
    social: false,
    urlOverride: 'settings',
});
//# sourceMappingURL=settings.js.map